$(document).on('ajaxComplete', function () {
  ht.resizeModal();
});
